import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { init as initApm } from '@elastic/apm-rum';
import { registerLicense } from '@syncfusion/ej2-base';
import { Provider } from 'react-redux';
import reportWebVitals from './reportWebVitals';
import store from './store/index';
// import ErrorBoundary from './errors/ErrorBoundary';
import './index.css';
import App from './components/app/App';


const root = ReactDOM.createRoot(document.getElementById('root'));
registerLicense('Ngo9BigBOggjHTQxAR8/V1NAaF1cWWhIfEx1RHxQdld5ZFRHallYTnNWUj0eQnxTdEFjW39YcHBXR2VcVkZ1WQ==');

initApm({
  serviceName: window.config.apmServiceName || 'myedu-ui',
  serverUrl: window.config.apmUrl,
  environment: window.config.elasticEnvironment,
  active: true,
  instrument: true,
  serviceVersion: process.env.REACT_APP_VERSION || window.config.apmVersion || 'test',
  transactionSampleRate: 1.0
});

root.render(
  // <React.StrictMode>
  <Provider store={store} >
    {/* <ErrorBoundary /> */}
    <BrowserRouter basename="/ai">
      <App />
    </BrowserRouter >
  </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
